import { CommonHelperFunctions, IUserSettingDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class UserSettingService {
  public static async Update(obj: IUserSettingDto): Promise<AxiosResponse> {
    try {
      return await Axios.put<IUserSettingDto, AxiosResponse>(`${backendUrl}/usersettings/update`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
